import { publicAxios } from "./axiosInstance";

const login = async (email, password) => {
  try {
    const response = await publicAxios.post("/Auth/Login", { email, password });

    return response;
  } catch (error) {
    console.error("...............Error in Login", error);
  }
};

export default login;
